export const viLang_en = {
  GLOBAL_LANGUAGE_NAME: 'English',
  GLOBAL_LANGUAGE_EN: 'en-GB',
  GLOBAL_LANGUAGE_PT: 'pt-PT',

  //Common Wording
  GLOBAL_ADD: 'Add',
  GLOBAL_DELETE: 'Delete',
  GLOBAL_UPDATE: 'Update',
  GLOBAL_CONTENT: 'Content',
  GLOBAL_NEW: 'New',
  GLOBAL_SAVE_BUTTON: 'Save',
  GLOBAL_CANCEL: 'Cancel',
  GLOBAL_RETURN_BUTTON: 'Return',
  GLOBAL_EQUIPMENT: 'Equipment',
  GLOBAL_EQUIPMENTS: 'Equipment List',
  GLOBAL_GLASSES: 'Glasses',
  GLOBAL_DONATION: 'Donation Entities',
  GLOBAL_SECTION_TABLE_TITLE: 'Manage ',
  GLOBAL_ADD_NEW: 'Add New ',
  GLOBAL_NAME: 'Name',
  GLOBAL_SEARCH: 'Search',
  GLOBAL_PROFILE: 'Profile',
  GLOBAL_USERS: 'Users',
  GLOBAL_PASSWORD: 'Password',
  GLOBAL_EVENT: 'Event',
  GLOBAL_LOGOUT: 'Logout',
  GLOBAL_ALL: 'All',
  GLOBAL_SHOWING: 'Showing',
  GLOBAL_RESULTS: 'Results',
  GLOBAL_LANGUAGE: 'Language',
  GLOBAL_PERIOD: 'Period',
  GLOBAL_PERIOD_STATE_CLOSED: 'Closed',
  GLOBAL_PERIOD_STATE_OPEN: 'Open',
  GLOBAL_TYPE: 'Type',
  GLOBAL_EQUIPMENT_TYPE: 'Equipment Type',
  GLOBAL_AMOUNT: 'Amount',
  GLOBAL_QUANTITY: 'Quantity',
  GLOBAL_QUANTITY_MIN: 'Qty.',
  GLOBAL_NO_RESULTS: 'No Results',
  GLOBAL_CODE: 'Code',
  GLOBAL_ERROR: 'Error',
  GLOBAL_ACCOUNT: 'Account',
  GLOBAL_TIME: 'Time',
  GLOBAL_DATE: 'Date',
  GLOBAL_DATE_TIME: 'Date Time',
  GLOBAL_DATE_TIME_CLOSE: 'Date Time Close',
  GLOBAL_RECEIPT: 'Receipt',
  GLOBAL_COMISSIONS: 'Comissions (%)',
  GLOBAL_CONTRACT: 'Contract',
  GLOBAL_ENTITY: 'Entity',
  GLOBAL_HOURS: 'Hours',
  GLOBAL_MINUTES: 'Minutes',
  GLOBAL_STORE: 'Store',
  GLOBAL_VAULT: 'Vault',
  GLOBAL_BILLS: 'Bills',
  GLOBAL_BILL: 'Bill',
  GLOBAL_COINS: 'Coins',
  GLOBAL_COIN: 'Coin',
  GLOBAL_CURRENCY: 'Currency',
  GLOBAL_USER_EQUIPMENTS: 'Your equipment',
  GLOBAL_PICK_A_DATE: 'Pick a date',
  GLOBAL_REASON: 'Reason',
  GLOBAL_MAINTENANCE: 'Maintenance',
  GLOBAL_AGENT: 'Agent',
  GLOBAL_LICENSE: 'License',
  GLOBAL_STATISTICS: 'Statistics',
  GLOBAL_AUDITLOG: 'AuditLog',
  GLOBAL_LOCATIONS: 'Locations',
  GLOBAL_LOCATION: 'Location',
  GLOBAL_IP: 'IP',
  GLOBAL_IP_LOCAL: 'Local IP',
  GLOBAL_GROUP: 'Group',
  GLOBAL_ENTITIES: 'Entities',
  GLOBAL_ADDRESS: 'Address',
  GLOBAL_LANGUAGES: 'Languages',
  GLOBAL_METHOD: 'Method',
  GLOBAL_ADDITIONAL_INFORMATION: 'Additional Information',
  GLOBAL_CLEAR: 'Clear',
  GLOBAL_DENOMINATION: ' Denomination',
  GLOBAL_DENOMINATION_MIN: ' Denom.',
  GLOBAL_INDEX: 'Index',
  GLOBAL_VALUE: 'Value',
  GLOBAL_WORKING_CAPITAL: 'Working Capital',
  GLOBAL_WORKING_CAPITAL_MIN: 'W.C.',
  GLOBAL_TICKET: 'Ticket',
  GLOBAL_TICKETS: 'Tickets',
  GLOBAL_CLIENT: 'Client',
  GLOBAL_URGENCY: 'Urgency',
  GLOBAL_OTHER: ' Other',
  GLOBAL_PRODUCT: 'Product',
  GLOBAL_PRODUCTS: 'Products',
  GLOBAL_COMMENTS: 'Comments',
  GLOBAL_ORIGIN: 'Origin',
  GLOBAL_SOLUTION: 'Solution',
  GLOBAL_GENERAL: 'General',
  GLOBAL_PARTICULAR: 'Particular',
  GLOBAL_IMPACT: 'Impact',
  GLOBAL_CLASSIFICATION: 'Classification',
  GLOBAL_CONTACT: 'Contact',
  GLOBAL_ACCEPTED: 'Accepted',
  GLOBAL_DECLARATION: 'Declaration',
  GLOBAL_SAFE: 'Safe',
  GLOBAL_ID_ENTITY: 'ID Entity',
  GLOBAL_EDIT: 'Edit',
  GLOBAL_SOURCE: 'Origin',
  GLOBAL_BEFORE: 'Before',
  GLOBAL_AFTER: 'After',
  GLOBAL_SYNC_COMMANDS: 'Sync Command',
  GLOBAL_DISTRIBUITIONS: 'Distribuitions',
  GLOBAL_DISTRIBUITION: 'Distribuition',
  GLOBAL_N_D: 'n/d',
  GLOBAL_DEVICES: 'Devices',
  GLOBAL_WAREHOUSE: 'Warehouse',
  GLOBAL_TODAY: 'Today',
  GLOBAL_DAY_AGO: '1 day ago',
  GLOBAL_DAYS_AGO: 'days ago',
  GLOBAL_MINUTE_AGO: 'minute ago',
  GLOBAL_MINUTES_AGO: 'minutes ago',
  GLOBAL_HOURS_AGO: 'hours ago',
  GLOBAL_LATITUDE: 'Latitude',
  GLOBAL_LONGITUDE: 'Longitude',
  GLOBAL_COUNTRY: 'Country',
  GLOBAL_OPTIONAL: 'Optional',
  GLOBAL_ONLY_NUMERIC_VALUES: 'Only numeric values are allowed',
  GLOBAL_INVALID_INPUT: 'Invalid input',
  GLOBAL_CAPACITY: 'Capacity',
  GLOBAL_MODE: 'Mode',
  GLOBAL_LIGHT: 'Light mode',
  GLOBAL_DARK: 'Dark mode',
  GLOBAL_OPERATION: 'Operation',
  GLOBAL_COMMAND: 'Command',
  GLOBAL_COMMAND_ID: 'Command ID',
  GLOBAL_FETCH_DATA: 'Fetching data',
  GLOBAL_BALANCE: 'Balance',
  GLOBAL_TOTAL_INVOICED: 'Total Invoiced',
  GLOBAL_TOTAL_COLLECTED: 'Total Collected',
  GLOBAL_TOTAL_COLLECTED_PREVIOUS: 'Total Collected (Previous)',
  GLOBAL_TOTAL_COLLECTED_RESPECTIVE: 'Total Collected (Respective)',
  GLOBAL_STATE: 'State',
  GLOBAL_ERROR_DETAILS: 'Error details',

  //Product
  PRODUCTS_TITLE: 'Products',
  PRODUCT_DETAILS: 'Product Details',
  PRODUCTS_ID: 'Product ID',
  PRODUCTS_PRICE: 'Price',
  PRODUCTS_NAME: 'Name',
  PRODUCTS_ADD: 'Add product',
  PRODUCTS_EDIT: 'Edit product',
  PRODUCTS_ADD_SUCCESS: 'Product added',
  PRODUCTS_ADD_ERROR: 'Error adding product',
  PRODUCTS_DELETE_SUCCESS: 'Product deleted',
  PRODUCTS_DELETE_ERROR: `Couldn't delete product`,
  PRODUCTS_EDIT_SUCCESS: 'Product edited',
  PRODUCTS_EDIT_ERROR: 'Error editing product',

  //Dispensers
  DISPENSERS_TITLE: ' Dispensers',
  DISPENSER_ID: 'Dispenser ID',
  DISPENSER_PRODUCT: 'Product',
  DISPENSER_STATUS: 'Status',
  DISPENSER_QUANTITY: 'Quantity',
  DISPENSER_NEW_QUANTITY: 'New quantity',
  DISPENSERS_ADD: 'Add dispenser',
  DISPENSERS_EDIT: 'Edit dispenser',
  DISPENSERS_ADD_SUCCESS: 'Dispenser added',
  DISPENSERS_ADD_ERROR: 'Error adding dispenser',
  DISPENSERS_DELETE_SUCCESS: 'Dispenser removed',
  DISPENSERS_DELETE_ERROR: `Couldn't delete dispenser`,
  DISPENSERS_EDIT_SUCCESS: 'Dispenser edited',
  DISPENSERS_EDIT_ERROR: 'Error editing dispenser',

  //Periods
  PERIODS_REPORT_ERROR: 'The report could not be obtained',
  PERIODS_RECEIPT_ERROR: 'The receipt could not be obtained',
  PERIODS_RECEIPT_NO_DATA: 'No data',

  // Locations
  LOCATIONS_OPEN_NEW: 'New location',
  LOCATIONS_OPEN_MAP: 'Open map',
  LOCATIONS_CLOSE_MAP: 'Close map',
  LOCATIONS_COUNTRY_SELECT: 'Choose a country',
  LOCATION_NEW: 'Add location',
  LOCATION_READ: 'Visualize location',
  LOCATION_EDIT: 'Edit location',
  LOCATION_NOT_DEFINED: 'Location not defined',
  LOCATION_CHOOSE_ENTID: 'Choose an entity',
  LOCATIONS_CHOOSE_LOCATION: 'Select locations',

  //Events Section
  EVENTS: 'Events',
  EVENTS_NEW: 'Add New Event',
  EVENT_ADDRESS: 'Address',
  EVENT_ZIP_CODE: 'Zip Code',
  EVENT_BEGIN_DATE: 'Begin Date',
  EVENT_BEGIN_DATE_PLACEHOLDER: 'From',
  EVENT_END_DATE: 'End Date',
  EVENT_END_DATE_PLACEHOLDER: 'To',
  EVENT_LAT: 'Lat',
  EVENT_LONG: 'Long',
  EVENT_ID: 'Event Id',
  EVENT_DATE_INFORMATION: 'Date Information',
  EVENT_INSTALLATION: 'Installation',
  EVENT_UNINSTALLATION: 'Uninstallation',
  EVENT_DETAILS_GENERAL: 'General Information',
  EVENT_DETAILS_GENERAL_EVENT_DATES: 'Event Dates',
  EVENT_DETAILS_GENERAL_EVENT_DATES_FROM: 'From',
  EVENT_DETAILS_GENERAL_EVENT_DATES_TO: 'to',
  EVENT_DETAILS_GENERAL_DIRECTIONS: 'Directions',
  EVENT_GLASS_RECEPTACLE: 'Receptacle',
  EVENT_GLASS_DELIVERY_ANIMATION: 'Delivery Animation',
  EVENT_AD_ORDER: 'Order',
  EVENT_ID_PLACEHOLDER: 'Enter Event Id',
  EVENT_NAME_PLACEHOLDER: 'Enter Event Name',
  EVENT_ZIP_CODE_PLACEHOLDER: '0000-000 City',
  EVENT_LAT_PLACEHOLDER: '0.000',
  EVENT_LONG_PLACEHOLDER: '0.000',
  EVENT_EQUIPMENT_FORM_TITLE: 'Add Equipment to Event',
  EVENT_EQUIPMENT_FORM_SELECT: 'Select the Equipment',
  EVENT_GLASS_FORM_TITLE: 'Add Glass to Event',
  EVENT_GLASS_FORM_GLASS: 'Select the Glass',
  EVENT_GLASS_FORM_SELECT_RECEPTACLE: 'Select the receptacle',
  EVENT_GLASS_FORM_RECEPTACLE_1: 'Receptacle 1',
  EVENT_GLASS_FORM_RECEPTACLE_2: 'Receptacle 2',
  EVENT_GLASS_FORM_DELIVERY: 'Select the delivery animation',
  EVENT_GLASS_FORM_RIGHT: 'Direct to the right side',
  EVENT_GLASS_FORM_LEFT: 'Direct to the left side',
  EVENT_AD_FORM_TITLE: 'Add Advertisement to Event',
  EVENT_AD_FORM_SELECT: 'Select the Advertisement',
  EVENT_AD_FORM_ORDER: 'Pick the order',
  EVENT_DON_FORM_TITLE: 'Add Donation Entity to Event',
  EVENT_DON_SELECT: 'Select the Donation Entity',
  EVENT_CODE: 'Event code',
  EVENT_DATE: 'Event date',
  EVENT_LOG: 'Event log',
  EVENT_LOG_CONSULT: 'Consult event log',
  EVENT_ADD_EVENT: 'Add event',
  EVENT_HELPDESK_DESTDESISOR: 'Destination Decisor',
  EVENT_HELPDESK_DESTDISPACTER: 'Destination Dispatcher',
  EVENT_HELPDESK_DESTDISTRIBUTIONLIST: 'Distribution List',
  EVENT_HELPDESK_DESTMONITOR: 'Monitor',
  EVENT_ACTUATION: 'Actuation',
  EVENT_MANAGEMENT: 'Event management',
  ADD_EVENT_SUCCESS: 'Event added',
  ADD_EVENT_ERROR: 'Failed to add event',
  EDIT_EVENT_SUCCESS: 'Event updated',
  EDIT_EVENT_ERROR: 'Failed to update event',
  DELETE_EVENT_SUCCESS: 'Event deleted',
  DELETE_EVENT_ERROR: 'Failed to delete event',

  // Delegation Section
  LOCATION_ADD_ALERT_SUCCESS: 'Location added',
  LOCATION_UPDATE_ALERT_SUCCESS: 'Location updated',
  LOCATION_ADD_ALERT_ERROR: 'An error occurred while adding the location',
  LOCATION_UPDATE_ALERT_ERROR: 'An error occurred while updating the location',
  LOCATION_DELETE_ALERT_SUCCESS: 'Location deleted',
  LOCATION_DELETE_ALERT_ERROR: 'An error occurred while deleting the location',
  LOCATION_DOES_NOT_EXIST: 'Location does not exist',

  //Equipment Section
  EQUIPMENT_ID: 'Equipment ID',
  EQUIPMENT_ID_MIN: 'EID',
  EQUIPMENT_SERIAL_NUMBER: 'Serial Number',
  EQUIPMENT_DESCRIPTION: 'Description',
  EQUIPMENT_IDENTIFICATION: 'Identification',
  EQUIPMENT_SOFTWARE_VERSION: 'Software Version',
  EQUIPMENT_SOFTWARE_VERSION_MIN: 'Soft. Version',
  EQUIPMENT_CYCLE: 'Cycle',
  EQUIPMENT_OCCUPATION: 'Occupancy',
  EQUIPMENT_COM_STATE: 'Status',
  EQUIPMENT_STATE: 'Equipment Status',
  EQUIPMENT_STATE_MIN: 'Equip. Status',
  EQUIPMENT_COM_DATE: 'Last Communication',
  EQUIPMENT_LAST_COM_DT: 'Last Communication Date/Time',
  EQUIPMENT_COM_DATE_MIN: 'Last Comm.',
  EQUIPMENT_LAST_OPER: 'Last Operation',
  EQUIPMENT_LAST_OPER_MIN: 'Last Op.',
  EQUIPMENT_LAST_OPER_DT: 'Last Operation Date/Time',
  EQUIPMENT_LAST_OPER_DT_MIN: 'Last Op. DT',
  EQUIPMENT_OCCUPATION_PER: '% Occupancy',
  EQUIPMENT_LOCAL: 'Location',
  EQUIPMENT_DETAILS_TITLE: 'Equipment Details',
  EQUIPMENT_DETAILS_SUBTITLE: 'Equipment Information',
  EQUIPMENT_ID_PLACEHOLDER: 'Please enter the Equipment ID',
  EQUIPMENT_FORM_TITLE: 'Add New Equipment',
  EQUIPMENT_EDIT: 'Edit equipment',
  EQUIPMENT_AUTOMATIC_CLOSE: 'Auto-close time',
  EQUIPMENT_TOTAL_AMOUNT: 'Total in Equipment',
  EQUIPMENT_TOTAL_AMOUNT_MIN: 'Total in Equip',
  EQUIPMENT_BILLS_RECYCLE: 'Bills recycler',
  EQUIPMENT_COINS_RECYCLE: 'Coins recycler',
  EQUIPMENT_STATE_OK: 'Ok',
  EQUIPMENT_STATE_INACTIVE: 'Inactive',
  EQUIPMENT_STATE_PICKUP: 'Pickup required',
  EQUIPMENT_STATE_CHARGE: 'Charging required',
  EQUIPMENT_STATE_ERROR: 'Some devices in error',
  EQUIPMENT_LIMIT_MAX: 'Maximum limit reached',
  EQUIPMENT_LIMIT_PICKUP: 'Pickup limit reached',
  EQUIPMENT_LIMIT_MIN: 'Minimum limit reached',
  EQUIPMENT_REGISTER: 'Register Equipment',
  EQUIPMENT_CONTRACT: 'Consult contract',
  EQUIPMENT_NO_CONTRACT: 'Equipment with no associated agreement',
  EQUIPMENT_CONSULT: 'Consult equipment',
  EQUIPMENT_CREATE_TICKET: 'Create ticket',
  EQUIPMENT_CONSULT_TICKET: 'Consult ticket',
  EQUIPMENT_AUTHORIZE_INITIATION: 'Authorize Initialization',
  EQUIPMENT_REASONS_DECLARATIONS: 'Reasons and Declarations',
  EQUIPMENT_ADD_NEW_REASON: 'Add new reason',
  EQUIPMENT_ADD_NEW_DECLARATION: 'Add new declaration',
  EQUIPMENT_UPDATE_REASON: 'Edit reason',
  EQUIPMENT_UPDATE_DECLARATION: 'Edit declaration',
  EQUIPMENT_LOCAL_IP: 'Local IP',
  EQUIPMENT_MAX_COINS_SAFE: 'Max coins in safe',
  EQUIPMENT_MAX_BILLS_SAFE: 'Max bills in safe',
  EQUIPMENT_ALMOST_FULL_SAFE: '% Almost full',
  EQUIPMENT_FULL_SAFE: '% Full',
  EQUIPMENT_CARD_INSERTION_TIME: 'Card insertion timeout',
  EQUIPMENT_CARD_REMOVAL_TIME: 'Card removal timeout',
  EQUIPMENT_DATA_INSERTION_TIME: 'Data insertion timeout',
  EQUIPMENT_DEPOSIT_INSERTION_TIME: 'Deposit timeout',
  EQUIPMENT_DECLARATION_TIME: 'Choose declaration timeout',
  EQUIPMENT_AMOUNT_CURRENCY: 'Amount currency inside safe',
  EQUIPMENT_ALMOST_FULL_AMOUNT: 'Amount for almost full safe',
  EQUIPMENT_FULL_AMOUNT: 'Amount for full safe',
  EQUIPMENT_EXISTENCE_RECYCLER: 'Exist. in Recycler',
  EQUIPMENT_WC_SURPLUS: 'Exceed Working Capital',
  EQUIPMENT_WC_LACKING: 'Missing Working Capital',
  EQUIPMENT_EXISTENCE_SAFE: 'Exist. in Safe',
  EQUIPMENT_TOTAL_EXISTENCE: 'Total Existences',
  EQUIPMENT_CONSULT_WORKING_CAPITAL: 'Consult stocks and working capital',
  EQUIPMENT_CONSULT_DISPENSERS: 'Consult dispensers',
  EQUIPMENT_EDIT_DISPENSERS: 'Edit dispensers',
  EQUIPMENT_EDIT_WORKING_CAPITAL: 'Edit config. currency/working capital',
  EQUIPMENT_FILL_EXISTENCE_WORKING_CAPITAL: 'Fill working capital with stocks',
  EQUIPMENT_CLEAR_WORKING_CAPITAL: 'Clear working capital',
  EQUIPMENT_UPDATE_WC_SUCCESS: 'Working capital updated',
  EQUIPMENT_UPDATE_WC_ERROR: 'Error updating working capital',
  EQUIPMENT_COUNTRY_SELECT: 'Choose a country',
  EQUIPMENT_CURRENCY_SELECT: 'Choose a currency',
  EQUIPMENT_ADD_SUCCESS: 'Equipment added',
  EQUIPMENT_ADD_ERROR: 'Error adding equipment',
  EQUIPMENT_MAX_CURRENCIES: 'Max nº of currencies',

  //Equipment Status Label
  EQUIPMENT_STATUS_LABEL_NOT_DEFINED: 'Not Defined',
  EQUIPMENT_STATUS_LABEL_DEFINED: 'Defined',
  EQUIPMENT_STATUS_LABEL_INICIALIZED: 'Inicialized',
  EQUIPMENT_STATUS_LABEL_ONLINE: 'Online',
  EQUIPMENT_STATUS_LABEL_OFFLINE: 'Offline',
  EQUIPMENT_STATE_BUTTON_OUT_OF_SERVICE: 'Out of service',
  EQUIPMENT_STATUS_IN_SERVICE_WITH_WARN: 'In service with warnings',
  EQUIPMENT_STATE_BUTTON_IN_SERVICE: 'In service',
  EQUIPMENT_STATE_LABEL_OUT_OF_SERVICE_FAKE_NOTE: 'Out of Service with suspect fake notes retained',
  EQUIPMENT_STATE_LABEL_TITLE: 'Equipment State',
  EQUIPMENT_STATE_LABEL_PRINTER: 'Printer',
  EQUIPMENT_STATE_LABEL_CARD_READER: 'Card Reader',
  EQUIPMENT_STATE_LABEL_RFID_READER: 'RFID Reader',
  EQUIPMENT_STATE_LABEL_UPS: 'UPS',
  EQUIPMENT_STATE_LABEL_PAY_SYSTEM: 'Pay System',
  EQUIPMENT_STATE_LABEL_MANUAL_STATE: 'Manual State',
  EQUIPMENT_STATE_LABEL_QUANTITY: 'Quantity',
  EQUIPMENT_STATE_LABEL_MAX_AMOUNT: 'Max amount',
  EQUIPMENT_STATE_LABEL_MIN_AMOUNT: 'Min amount',
  EQUIPMENT_STATE_LABEL_DEC_AMOUNT: 'Amount for declaration',
  EQUIPMENT_STATE_BUTTON_RESTART: 'Restart  ',
  EQUIPMENT_STATE_BUTTON_SHUTDOWN: 'Shutdown',
  EQUIPMENT_STATE_BUTTON_OPEN_ESCROW: 'Open escrow',
  EQUIPMENT_STATE_BUTTON_CLOSE_ESCROW: 'Close escrow',
  EQUIPMENT_NO_INFORMATION: 'No information available',
  EQUIPMENT_NO_DATA: 'No data available',
  EQUIPMENT_NO_STATUS: 'No status available',
  S_LEFT_DOOR_LABEL: 'Left door',
  S_RIGTH_DOOR_LABEL: 'Right door',
  S_MAINT_STRUCTURE_LABEL: 'Maint structure',
  S_SAFE_DOOR_LABEL: 'Safe door',
  S_SAFE_DOOR_LOCK_LABEL: 'Safe door lock',
  S_BAG_LABEL: 'Bag',
  S_ESCROW_LABEL: 'Escrow',
  S_ESCROW_MONEY_INSIDE_LABEL: 'Escrow money inside',
  S_COINS_DOOR_LABEL: 'Coins door',
  S_COINS_DOOR_LOCK_LABEL: 'Coins door lock',
  S_PROCESSOR_DRAWER_LABEL: 'Processor drawer',
  S_BILLS_DOOR_LABEL: 'Bills door',
  S_BILLS_DOOR_LOCK_LABEL: 'Bills door lock',
  S_COINS_DRAWER_LABEL: 'Coins drawer',
  S_COINS_SAFE_LABEL: 'Coins safe',
  EQUIPMENT_STATE_IN_SERVICE_WITH_ALERTS: 'In service with alerts',
  EQUIPMENT_SAFE_OCC_PERC: 'Safe Ocuppancy (%)',
  EQUIPMENT_SAFE_OCC_PERC_MIN: '% Safe Occup.',

  //Equipment Status
  OK: 'Ok',
  YES: 'Yes',
  NO: 'No',
  IN_ERROR: 'In error',
  NO_PAPER: 'No paper',
  CARD_INSIDE: 'Card inside',
  LOW_PAPER: 'Low paper',
  OUT_OF_SERVICE: 'Out of service',
  FULL: 'Full',
  NEAR_FULL: 'Near full',
  OPEN: 'Open',
  CLOSE: 'Close',
  LOCKED: 'Locked',
  UNLOCKED: 'Unlocked',
  NOT_INSTALLED: 'Not installed',
  VALIDATOR_IN_ERROR: 'Validator(s) in error',
  UPS_ON_BATTERY: 'UPS on battery',
  EDIT_EQUIPMENTS_ALERT_UPDATED_SUCCESS: 'Equipment updated',
  EDIT_EQUIPMENTS_ALERT_UPDATED_ERROR: 'Error updating equipment',

  EQUIPMENT_STATE_LABEL_COIN_VALIDATOR: 'Coin validator status',
  EQUIPMENT_STATE_LABEL_BILL_VALIDATOR: 'Bill validator status',
  EQUIPMENT_STATE_LABEL_COIN_SAFE: 'Coin safe status',
  EQUIPMENT_STATE_LABEL_BILL_SAFE: 'Bill safe status',
  EQUIPMENT_STATE_LABEL_COIN_RECYCLER: 'Coin recycler status',
  EQUIPMENT_STATE_LABEL_BILL_RECYCLER: 'Bill recycler status',
  EQUIPMENT_STATE_LABEL_AUTOMATIC_PAYMENT: 'Automatic payment',
  EQUIPMENT_STATE_LABEL_PRODUCT_DISPENSER: 'Product dispenser',

  REMOVE_REASON: 'Are you sure you want to delete this reason?',
  REMOVE_DECLARATION: 'Are you sure you want to delete this declaration?',
  ADD_REASON_SUCCESS: 'Reason added',
  ADD_DECLARATION_SUCCESS: 'Declaration added',
  ADD_REASON_ERROR: 'Error adding reason',
  ADD_DECLARATION_ERROR: 'Error adding declaration',
  UPDATE_REASON_SUCCESS: 'Reason updated',
  UPDATE_DECLARATION_SUCCESS: 'Declaration updated',
  UPDATE_REASON_ERROR: 'Error updating reason',
  UPDATE_DECLARATION_ERROR: 'Error updating declaration',
  REMOVE_REASON_SUCCESS: 'Reason removed',
  REMOVE_DECLARATION_SUCCESS: 'Declaration removed',
  REMOVE_REASON_ERROR: 'Error removing reason',
  REMOVE_DECLARATION_ERROR: 'Error removing declaration',
  EQUIPMENT_AUTHORIZE_INITIALIZATION_SUCCESS: 'Initialization authorized',
  EQUIPMENT_AUTHORIZE_INITIALIZATION_ERROR: 'Failed to authorize initialization',

  // Deposit equipments transactions
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_EID: 'EID',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_EQUIPMENT_TYPE: 'Type',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_BANK: 'Bank',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_BRANCH: 'Branch',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_STATUS: 'Status',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_EQUIPMENT_STATE: 'Equip. State',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_DATE_LAST_COMMUNICATION: 'Last com.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_OPERATION: 'Last Op.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_OPERATION_DATE: 'Last Op. Dt.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_PERIOD: 'Period',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_CASH_BALANCE: 'Cash Balance',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_SOFTWARE_VERSION: 'Soft. version',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_ALERT_COMMAND: 'Command sent successfuly',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_ALERT_SELECT_FILE: 'Please select a file!',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_BUTTON_ALL_IN_SERVICE: 'All in service',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_BUTTON_ALL_OUT_OF_SERVICE: 'All out of service',

  //Equipment agreeType
  AGREE_STATE_0: 'n/d',
  AGREE_STATE_1: 'Active',
  AGREE_STATE_2: 'Pendent',
  AGREE_STATE_3: 'Canceled',
  AGREE_STATE_4: 'Non-compliance',

  //Glasses Section
  GLASS: 'Glass',
  GLASS_NEW: 'Add New Glass',
  GLASS_IMAGE: 'Image',
  GLASS_DESCRIPTION: 'Description',
  GLASS_DETAILS_TITLE: 'Glass Details',
  GLASS_ID: 'Glass ID',
  GLASS_ID_PLACEHOLDER: 'Enter Glass ID',
  GLASS_CODE: 'Code',
  GLASS_CODE_PLACEHOLDER: 'Enter the code',
  GLASS_SELECT_IMAGE: 'Select an Image',
  GLASS_DESCRIPTION_PLACEHOLDER: 'Enter Glass description',
  GLASS_SIZE_TYPE: 'Size Type',
  GLASS_SIZE_TYPE_PLACEHOLDER: 'Enter size type',
  GLASS_READ: 'Read Glass',

  //Glass Category
  CATEGORY: 'Category',
  CATEGORIES: 'Categories',
  CATEGORY_DESCRIPTION: 'Description',
  CATEGORY_NEW: 'New Category',

  //Advertising Section
  ADVERTISEMENTS: 'Advertisements',
  ADVERTISING_NEW: 'Add New Advertisement',
  ADVERTISING_FILE: 'File',
  ADVERTISING_DURATION: 'Duration',
  ADVERTISING_SECONDS: 'Seconds',
  ADVERTISING_SECS: 'secs',
  ADVERTISING_DETAILS_TITLE: "Advertisement's Details",
  ADVERTISING: 'Ad',
  ADVERTISING_ID: 'Advertisemente Id',
  ADVERTISING_ID_PLACEHOLDER: 'Enter Advertisement Id',

  //Donation Entities Section
  DONATION_ENTITY: 'Entity',
  DONATION_ENTITIES: 'Entities',
  DONATION_ENTITIES_LOGO: 'Logo',
  DONATION_ENTITY_ID: 'Donation Entity ID',
  DONATION_ENTITY_ID_PLACEHOLDER: "Please enter entity's ID number",
  DONATION_ENTITY_NAME_PLACEHOLDER: "Please enter entity's name",
  DONATION_ENTITY_SELECT_LOGO: 'Select the logo',
  DONATION_ENTITY_FORM_TITLE: 'Add New Entity',

  //Login
  LOGIN_ENTITY: 'Entity',
  LOGIN_USER: 'User',
  LOGIN_BUTTON: 'Login',
  LOGIN_EMAIL: 'Login with e-mail',
  LOGIN_USERID: 'Login with UserID',

  //Alert
  ALERT_ERROR_CODE: 'Code',
  ALERT_ERROR_MESSAGE: 'Message',

  //Users
  USER_UID: 'User ID',
  USER_EMAIL: 'Email',
  USER_EMAIL_PLACEHOLDER: 'example@email.com',
  USER_CARD: 'Card',
  USER_CARD_PLACEHOLDER: "Please enter User's card",
  USER_REGION: 'Region',
  USER_LANG: 'Language',
  USER_LANG_EN: 'English',
  USER_LANG_PT: 'Portuguese',
  USER_NEW: 'Add New User',
  USER_ENTITY: 'Entity',
  USER_ENTITY_PLACEHOLDER: 'Select the Entity',
  USER_ID: 'User ID',
  USER_ID_PLACEHOLDER: 'Select the User ID',
  USER_NAME_PLACEHOLDER: "Please enter the User's name",
  USER_MOBILE: 'Cell Phone',
  USER_PHONE: 'Phone',
  USER_MOBILE_PLACEHOLDER: "Please enter the User's phone number",
  USER_PERMISSIONS: 'Permissions',
  USER_CONFIRM_PASSWORD: 'Confirm Password',
  USER_CONFIRM_CURRENT_PASSWORD: 'Please confirm your current password',
  USER_CHANGE_PASSWORD: 'Change Password',
  USER_NEW_PASSWORD: 'New Password',
  USER_NEW_PASSWORD_ERROR: 'Passwords must match',
  USER_PIN: 'PIN Code',
  USER_CHANGE_PIN: 'Change PIN',
  USER_NEW_PIN: 'New PIN Code',
  USER_CONFIRM_PIN: 'Confirm PIN Code',
  USER_NEW_PIN_ERROR: 'PIN codes must match',
  USER_DELETE_CONFIRM: 'Are you certain you wish to delete this user? This action is irreversible',
  USER_CONTACT_INFO: 'Contact Information',
  USER_IMPORT_CSV_FILE:'Import',
     USER_IMPORT_SUCCESS:'File imported',
USER_IMPORT_ERROR:'Failed to import file',
  ADD_USER_ALERT_UPDATE_SUCCESS: 'User created',
  ADD_USER_ALERT_UPDATE_ERROR: 'Error creating user, please check the fields and try again',
  EDIT_USER_ALERT_UPDATE_SUCCESS: 'User updated',
  EDIT_USER_ALERT_UPDATE_ERROR: 'Error updating user',
  EDIT_USER_ALERT_DELETE_ERROR: 'Error deleting user',
  EDIT_USER_ALERT_UPDATE__PASSWORD_ERROR: 'Invalid password',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_1: 'User management and permissions',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_2: 'System Configurations',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_3: 'Eq. Non Financial Remote Oper.',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_4: 'Technician',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_1: 'Financial data',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_2: 'CIT',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_3: 'Eq. Financial Remote Oper.',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_4: 'Operator',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_5: 'APM',

  //app4
  APP4_OPT0: 'Agreement management',
  APP4_OPT1: 'Costumers management',
  APP4_OPT3: 'Helpdesk',
  APP4_OPT5: 'Event & Counter management',

  //app5
  APP5_OPT0: 'Products management',
  APP5_OPT1: 'Productions management',
  APP5_OPT2: 'Product reception',

  //app100
  APP100_OPT0: 'Financial data',
  APP100_OPT1: 'Stock',
  APP100_OPT2: 'Documents',
  USER_DELEGATIONS: 'Delegations',
  USER_DELEGATION: 'Delegation',
  USER_MY_PROFILE: 'My Profile',
  USER_PROFILE: 'Profile',

  //Movements
  PROCESSED_GLASS_PERIOD: 'Period',
  PROCESSED_GLASS_ID: 'ID',
  PROCESSED_GLASS_STATUS: 'Status',
  SUCCESS: 'Collected',
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
  PROCESSED_GLASS_ERROR: 'Error',
  NONE: ' ',
  INTERNAL: 'Internal Error',
  NO_GLASS_ID: 'Unrecognized glass',
  PROCESSED_GLASS_REFUND_TYPE: 'Refund Type',
  CASH: 'Cash',
  MULTIBANCO: 'MB',
  DONATION: 'Donation',
  PROCESSED_GLASS_TUBE: 'Tube',
  PROCESSED_GLASS_INITIAL_DATE: 'Intitial Date',
  PROCESSED_GLASS_END_DATE: 'End Date',
  PROCESSED_GLASS_SEARCH_PLACEHOLER: 'Select an option',

  //Transactions
  TRANSACTIONS: 'Transactions',
  TRANSACTION: 'Transaction',
  TRANSACTION_ID: '  Transaction ID',
  TRANSACTION_DETAILS: 'Transaction Details',
  TRANSACTION_RECEIVED: 'Received',
  TRANSACTION_DISPENSED: 'Dispensed',
  TRANSACTION_PAYMENT_METHOD: 'Payment Method',
  TRANSACTION_USER_CASHIER: 'User/Cashier',
  TRANSACTION_DEPOSITOR: 'Depositor',
  TRANSACTION_EXTERNAL_ID: 'External ID',
  TRANSACTION_NUMBER: 'Transaction Number',
  TRANSACTION_NUMBERS: 'Transaction Numbers',
  TRANSACTION_NUMBERS_FULL: 'Number of Transactions',
  TRANSACTION_AMOUNT_CHARGED: 'Amount Charged',
  TRANSACTION_COMISSION_AMOUNT: 'Commission Amount',
  TRANSACTION_AMOUNT_CREDITED: 'Amount Credited',
  TRANSACTION_REJECTED: 'Rejected',
  TRANSACTION_SUSPECT: 'Suspect',
  TRANSACTION_NOTE_SN: 'S.N. Banknote',
  TRANSACTION_INITIAL_DATE: 'Initial date',
  TRANSACTION_END_DATE: 'End date',
  TRANSACTION_BANKING_DETAILS: 'Banking details',
  TRANSACTION_NO_LOG: 'No transaction selected',
  TRANSACTION_LOG_SUCCESS: 'Log fetched',
  TRANSACTION_LOG_ERROR: 'Log not available',
  TRANSACTION_LOG_NO_DATA: 'No data available for this transaction',
  TRANSACTION_LOG_MISSING_PARAMS: 'Missing transaction parameters',
  TRANSACTION_DOC: 'Document',
  TRANSACTION_FINANCIAL_ONLY: 'Financial Only',
  TRANSACTION_TYPE: 'Transaction Type',
  TRANSACTION_TYPE_FT: 'FT',
  TRANSACTION_TYPE_TX: 'TX',
  TRANSACTION_REPORT_ERROR: 'Error getting report',

  CASH_COLLECTIONS: 'Cash Collections',
  CASH_COLLECTION_DETAIL: 'Cash Collection Summary',
  CASH_COLLECTION_EXCESS: 'Excess',
  CASH_COLLECTION_CUMULATIVE_EXCESS: 'Cumulative excess',
  CASH_COLLECTION_CUMULATIVE_EXCESS_PREVIOUS: 'Previous Cumulative excess',
  CASH_COLLECTION_WORKING_CAPITAL_EXCESS_REMOVED_SHORT: 'W. Cap. Exc. Rem.',
  CASH_COLLECTION_WORKING_CAPITAL_EXCESS_REMOVED: 'Working Capital Excess Removed',
  CASH_COLLECTION_TOTAL_LOADED: 'Total Loaded',
  CASH_COLLECTION_FIRST_PERIOD_OPEN_DATE: 'First Period Opening Date',
  CASH_COLLECTION_LAST_PERIOD_CLOSE_DATE: 'Last Period Closing Date',

  //Transactions type:
  TRANSACTION_TYPE_CASH: 'Cash',
  TRANSACTION_TYPES_MULTIBANCO: 'MB',

  //Currency Table
  CURRENCY_TABLE_CASH_IN: 'Incoming Cash',
  CURRENCY_TABLE_CASH_OUT: 'Outgoing Cash',
  CURRENCY_TABLE_READING: 'Reading detail',

  //Enterprise Equipment Periods
  ENTERPRISE_PERIOD: 'Periods',
  ENTERPRISE_EQUIP_PERIODS: 'Periods',
  ENTERPRISE_EQUIP_PERIODS_SHORT: 'Equip. Periods',
  ENTERPRISE_EQUIP_PERIODS_DT_OPEN: 'Date/Time open',
  ENTERPRISE_EQUIP_PERIODS_DT_CLOSE: 'Date/Time close',
  ENTERPRISE_EQUIP_PERIODS_USER_OPEN: 'User Open',
  ENTERPRISE_EQUIP_PERIODS_USER_CLOSE: 'User Close',
  ENTERPRISE_EQUIP_PERIODS_PAYMENT_AMOUNTS: 'Payment Amount',
  ENTERPRISE_EQUIP_PERIODS_PAYMENT_AMOUNTS_MIN: 'Paymnt. Amnt.',
  ENTERPRISE_EQUIP_PERIODS_PAYMENT_CLOSE_CODE: 'Code (close)',
  PERIOD_TOTAL_AMOUNT: 'Total Amount Received',
  PERIOD_TOTAL_PAID: 'Total Amount Paid',
  PERIOD_TOTAL_PAID_CASH: 'Cash Payments',
  PERIOD_TOTAL_PAID_CARD: 'Card Payments',

  //Bank Transactions
  BANK_TRANSACTIONS: 'Bank Transactions',

  //Dashboard
  DASHBOARD: 'Dashboard',
  DASHBOARD_EQUIPMENT_LIST: 'List of Equipment Status',
  DASHBOARD_CURRENT_PERIOD: 'Current period',
  DASHBORAD_ENTITY: 'Installed Equipment Summary',
  DASHBOARD_OCCUPANCY: 'Occ(%)',
  DASHBOARD_LAST_TRANSACTION: 'Last Transaction',
  DASHBOARD_LAST_TRANSACTION_SHORT: 'Last Tx',
  DASHBOARD_ALMOST_FULL: 'Almost full',
  DASHBOARD_FULL: 'Full',
  DASHBOARD_EMPTY: 'Empty',
  DASHBOARD_LAST_OPERATIONS: 'Last Operations',
  DASHBOARD_FULL_AMOUNT: 'Full Amount',
  DASHBOARD_RECEIVED_TODAY: 'Received Today',
  DASHBOARD_ALL_EQUIPMENTS: 'All Equipment',
  DASHBOARD_MAX_LAST_DAYS: '(Max. last 7 days)',
  DASHBOARD_AMOUNT_PER_DAY: 'Amount per Day',
  DASHBOARD_AMOUNT_PER_DAY_EURO: 'Amount per Day (€)',
  DASHBOARD_AVG_7_DAYS: 'Avg. 7 days',
  DASHBOARD_AVG_PREV_WEEK: 'Avg. Prev. Week',
  DASHBOARD_AVG_30_DAYS: 'Avg. 30 Days',
  DASHBOARD_AVG_PREV_MONTH: 'Avg. Prev. Month',
  DASHBOARD_PERIOD_OPEN_DATE: 'Period Opening Date',
  DASHBOARD_PERIOD_CLOSE_DATE: 'Period Closing Date',
  DASHOBOARD_PERIOD_TOTAL_EQUIPMENT: 'Total Equipment Value',
  DASHBOARD_PERIOD_MONEY_PAY: 'Cash Payments',
  DASHBOARD_PERIOD_CARD_PAY: 'Card Payments',
  DASHBOARD_PERIOD_NUMBER: 'Nº ',
  DASHBOARD_PERIOD_DISPENSER_PRODUCT_NAME: 'Product Name',
  DASHBOARD_PERIOD_DISPENSER_STATUS: 'Status',
  DASHBOARD_EQUIPMENT_PRODUCT_DISPENSER: 'Dispensers',

  //Payment methods
  VALUE_TYPE_CASH: 'Cash',
  VALUE_TYPE_MULTIBANCO: 'Card (MB)',

  // Transactions type
  OP_01010101_LABEL: 'Payment',
  OP_01010101_LABEL_MIN: 'Payment',
  OP_01010122_LABEL: 'Payment Canceled',
  OP_01010122_LABEL_MIN: 'P. Canceled',
  OP_01010123_LABEL: 'Payment Recovered',
  OP_01010123_LABEL_MIN: 'P. Recovered',
  OP_01010125_LABEL: 'Payment Rejected',
  OP_01010125_LABEL_MIN: 'P. Rejected',
  OP_01010128_LABEL: 'Payment Rejected by error',
  OP_01010128_LABEL_MIN: 'P.Rej. by error',
  OP_01010201_LABEL: 'Deposit',
  OP_01010201_LABEL_MIN: 'Deposit',
  OP_01010202_LABEL: 'Deposit by timeout',
  OP_01010202_LABEL_MIN: 'Deposit',
  OP_01010222_LABEL: 'Deposit canceled',
  OP_01010222_LABEL_MIN: 'D. Canceled',
  OP_01010223_LABEL: 'Deposit Recovered',
  OP_01010223_LABEL_MIN: 'D. Recovered',
  OP_01010224_LABEL: 'Deposit canceled by timeout',
  OP_01010224_LABEL_MIN: 'D. Canceled',
  OP_01010225_LABEL: 'Deposit rejected',
  OP_01010225_LABEL_MIN: 'D. Rejected',
  OP_01010226_LABEL: 'Deposit rejected w/ money remove timeout',
  OP_01010226_LABEL_MIN: 'D. Rejected',
  OP_01010227_LABEL: 'Deposit with error rejected by timeout',
  OP_01010227_LABEL_MIN: 'D. Rejected',
  OP_01010228_LABEL: 'Deposit with error rejected',
  OP_01010228_LABEL_MIN: 'D. Rejected',
  OP_01010229_LABEL: 'Deposit with error rejected w/ money remove timeout',
  OP_01010229_LABEL_MIN: 'D. Rejected',
  OP_01010230_LABEL: 'Transaction canceled due to lack of response, needs manual resolution',
  OP_01010230_LABEL_MIN: 'Transaction canceled due to lack of response, needs manual resolution',
  OP_01010231_LABEL: 'Deposit with suspect fake banknotes rejected by timeout',
  OP_01010231_LABEL_MIN: 'Deposit with suspect fake banknotes rejected by timeout',
  OP_01010232_LABEL: 'Deposit with suspect fake banknotes rejected',
  OP_01010232_LABEL_MIN: 'Deposit with suspect fake banknotes rejected',
  OP_01010233_LABEL: 'Deposit with suspect fake banknotes w/ money remove timeout',
  OP_01010233_LABEL_MIN: 'Deposit with suspect fake banknotes w/ money remove timeout',
  OP_01010301_LABEL: 'Withdrawal',
  OP_01010301_LABEL_MIN: 'Withdrawal',
  OP_01010322_LABEL: 'Withdrawal Canceled',
  OP_01010322_LABEL_MIN: 'W. Canceled',
  OP_01010328_LABEL: 'Withdrawal rejected by error',
  OP_01010328_LABEL_MIN: 'W. Canceled',
  OP_01010334_LABEL: 'Withdrawal Incomplete',
  OP_01010334_LABEL_MIN: 'W. Incomplete',
  OP_01010401_LABEL: 'Return',
  OP_01010401_LABEL_MIN: 'Return',
  OP_01011101_LABEL: 'Load',
  OP_01011101_LABEL_MIN: 'Load',
  OP_01011122_LABEL: 'Load Canceled',
  OP_01011122_LABEL_MIN: 'Load Canceled',
  OP_01011123_LABEL: 'Load Recovered',
  OP_01011123_LABEL_MIN: 'Load Recovered',
  OP_01011128_LABEL: 'Load canceled by error',
  OP_01011128_LABEL_MIN: 'Load C. by erro',
  OP_01011201_LABEL: 'Send to Safe',
  OP_01011201_LABEL_MIN: 'Send to Safe',
  OP_01011222_LABEL: 'Send to Safe Canceled',
  OP_01011222_LABEL_MIN: 'StS Canceled',
  OP_01011223_LABEL: 'Send to Safe Recovered',
  OP_01011223_LABEL_MIN: 'StS Recovered',
  OP_01011228_LABEL: 'Send to Safe Rejected by error',
  OP_01011228_LABEL_MIN: 'StS Rejected',
  OP_01010901_LABEL: 'Manual deposit',
  OP_01010901_LABEL_MIN: 'M. Deposit',
  OP_01011001_LABEL: 'Deposit reversal',
  OP_01011001_LABEL_MIN: 'Deposit R.',
  OP_02120503_LABEL: 'Open Period',
  OP_02120503_LABEL_MIN: 'Open Period',
  OP_02120506_LABEL: 'Close Period',
  OP_02120506_LABEL_MIN: 'Close Period',
  OP_01011301_LABEL: 'Change',
  OP_01011301_LABEL_MIN: 'Change',
  OP_01011322_LABEL: 'Change Canceled',
  OP_01011322_LABEL_MIN: 'Change Canceled',
  OP_01011323_LABEL: 'Change recovered',
  OP_01011323_LABEL_MIN: 'Change recovered',
  OP_01011325_LABEL: 'Change Incomplete',
  OP_01011325_LABEL_MIN: 'Change Incomplete',
  OP_01011334_LABEL: 'Change Incomplete',
  OP_01011334_LABEL_MIN: 'Change Incomplete',
  OP_01011501_LABEL: 'Correction',
  OP_01011501_LABEL_MIN: 'Correction',
  OP_01011528_LABEL: 'Correction',
  OP_01011528_LABEL_MIN: 'Correction',
  OP_01011401_LABEL: 'Product load',
  OP_01011401_LABEL_MIN: 'Product load',
  OP_01012101_LABEL: 'Safe removal',
  OP_01012101_LABEL_MIN: 'Safe removal',
  OP_01012122_LABEL: 'Safe removal canceled',
  OP_01012122_LABEL_MIN: 'Safe removal canceled',
  OP_01010323_LABEL: 'Withdrawal recovered',
  OP_01010323_LABEL_MIN: 'W. recovered',

  OP_1_LABEL: 'Payment',
  OP_1_LABEL_MIN: 'Payment',
  OP_2_LABEL: 'Authorization and Purchase',
  OP_2_LABEL_MIN: 'Auth. and Purchase',
  OP_3_LABEL: 'Authorization',
  OP_3_LABEL_MIN: 'Authorization',
  OP_4_LABEL: 'Refund',
  OP_4_LABEL_MIN: 'Refund',
  OP_5_LABEL: 'Hopper Load',
  OP_5_LABEL_MIN: 'Hopper Load',
  OP_6_LABEL: 'Hopper Audit',
  OP_6_LABEL_MIN: 'Hopper Audit',
  OP_7_LABEL: 'Open Safe',
  OP_7_LABEL_MIN: 'Open Safe',
  OP_8_LABEL: 'Deposit',
  OP_8_LABEL_MIN: 'Deposit',
  OP_9_LABEL: 'Period Open',
  OP_9_LABEL_MIN: 'Period Open',
  OP_10_LABEL: 'Period Close',
  OP_10_LABEL_MIN: 'Period Close',

  //Transactions status
  TRANSACTIONS_STATUS_WAITING: 'Waiting',
  TRANSACTIONS_STATUS_WILL_NOT_BE_SENT: 'Done',
  TRANSACTIONS_STATUS_SET_AS_NOT_TO_SEND: 'Done',
  TRANSACTIONS_STATUS_SENDED_TO_COREBANKING: 'Communicated',
  TRANSACTIONS_STATUS_CARD_CHECKED: 'Card checked',
  TRANSACTIONS_STATUS_DEPOSIT_PARCIAL_RECEIVED: 'Parcial received',
  TRANSACTIONS_STATUS_WAITING_DECLARATION: 'Waiting declaration',
  TRANSACTIONS_XLS_ERROR: 'Error generating XLS file',

  //APMs
  APM_TRANSACTIONS: 'Automatic Payment Transactions',
  APM_TRANSACTIONS_ACRONYM: 'A. P. Transactions',
  APM_PERIODS: 'Automatic Payment Periods',
  APM_PERIODS_ACRONYM: 'A. P. Periods',
  APM_CLOSE_PERIODS: 'Automatic Payment Closed Periods',
  APM_CLOSE_PERIODS_ACRONYM: 'A. P. Closed Periods',
  APM_POS: 'Automatic Payment Equipment',
  APM_POS_ACRONYM: 'A. P. Equipment',

  // HelpDesk
  HELPDESK_EQUIPMENTS: 'Ms Equipment',
  HELPDESK_ENTITIES: 'MS Entities',
  HELPDESK_TICKETS: 'MS Tickets',
  HELPDESK_CONTRACTS: 'MS Contracts',
  HELPDESK_MAINTENANCE_COMPANY: 'Maintenance company',
  HELPDESK_MAINTENANCE_AGENCY: 'Maintenance agency',
  HELPDESK_CHOOSE_ENTITY: 'Choose entity',

  //Helpdesk entity types
  HELPDESK_ADD_ENTITY: 'Add entity',
  HELPDESK_ENTITY_REMOVE: 'Are you sure you want to delete this entity?',
  ENTITY_TYPE_0: 'Company',
  ENTITY_TYPE_1: 'Agent',
  ENTITY_TYPE_2: 'Supplier',
  ENTITY_TYPE_3: 'Maintenance Service Provider',
  ENTITY_TYPE_NULL: 'All',
  ENTITY_EXTERNAL_DATA: 'External data',
  ENTITY_AUTO_ENTID: 'Automatically generated',
  ENTITY_NEW_ENTITY: 'New entity',
  ENTITY_ID: 'Entity ID',
  ENTITY_NOT_DEFINED: 'Entity not defined',

  //Helpdesk dit Entity
  EDIT_ENTITY_FORM_LABEL_GID: 'Group (GID)',
  EDIT_ENTITY_FORM_LABEL_LOGO: 'Logo',
  EDIT_ENTITY_FORM_LABEL_USESHIFTS: 'Shifts',
  EDIT_ENTITY_FORM_LABEL_PRINTTYPE: 'Print type',
  EDIT_ENTITY_FORM_LABEL_REPORTTYPE: 'Report type',
  EDIT_ENTITY_FORM_LABEL_SIBSMERCHANTCODE: 'Sibs Mech. Code',
  EDIT_ENTITY_FORM_LABEL_BILLINGENTITY: 'Billing entity',
  EDIT_ENTITY_FORM_LABEL_OWNERID: 'Owner ID',
  EDIT_ENTITY_FORM_LABEL_ACTIVITY: 'Activity',
  EDIT_ENTITY_FORM_LABEL_BILLVOLUME: 'Bill volume',
  EDIT_ENTITY_LABEL_READ: 'Visualize entity',
  EDIT_ENTITY_LABEL_EDIT: 'Edit entity',
  EDIT_ENTITY_FORM_LABEL_ACTIVITY_NOT_DEFINED: 'Not Defined',
  EDIT_ENTITY_CONTROLLER_ALERT_DELETE_CONFIRM: 'Do you really want to delete the entity',
  EDIT_ENTITY_CONTROLLER_ALERT_DELETE_SUCCESS: 'Entity deleted with success',

  //Helpdesk Tickets
  HELPDESK_ADD_TICKET: 'Add Ticket',
  HELPDESK_TICKET_STATUS_0: 'Open',
  HELPDESK_TICKET_STATUS_1: 'Close',
  HELPDESK_TICKET_STATUS_2: 'Reopen',
  HELPDESK_TICKET_STATUS_3: 'Discussion',
  HELPDESK_TICKET_STATUS_4: 'Clarification',
  HELPDESK_TICKET_STATUS_5: 'Create IR',
  HELPDESK_TICKET_STATUS_6: 'Closed IR',
  HELPDESK_TICKETS_URGENCY_0: 'Immediately',
  HELPDESK_TICKETS_URGENCY_1: 'High',
  HELPDESK_TICKETS_URGENCY_2: 'Medium',
  HELPDESK_TICKETS_URGENCY_3: 'Low',
  HELPDESK_TICKETS_URGENCY_4: 'None',
  HELPDESK_TICKET_CLASSIFICATION_0: 'Error',
  HELPDESK_TICKET_CLASSIFICATION_1: 'Change',
  HELPDESK_TICKET_CLASSIFICATION_2: 'External Error',
  HELPDESK_TICKET_CLASSIFICATION_3: 'Problem',
  HELPDESK_TICKET_STATUS: 'Status',
  HELPDESK_TICKET_OPEN_DT: 'Open date',

  //classifications
  HELPDESK_TICKET_MANAGE: 'Manage',
  HELPDESK_TICKET_LIST: 'List',
  HELPDESK_TICKET_FAULT: 'Fault',
  HELPDESK_TICKET_CAUSE: 'Cause',
  HELPDESK_TICKET_ACTION: 'Action',
  HELPDESK_TICKET_FAULTS: 'Faults',
  HELPDESK_TICKET_CAUSES: 'Causes',
  HELPDESK_TICKET_ACTIONS: 'Actions',
  HELPDESK_TICKET_MANAGE_CLASSIFICATION: 'Manage ticket classifications',

  //Helpdesk edit ticket
  HELPDESK_TICKET_UPDATE_COMMUNICATION_CHANNEL: 'Communication channel',
  HELPDESK_TICKET_UPDATE_ISSUE_TYPES: 'Issue type',
  HELPDESK_TICKET_UPDATE_CHANGE_REQUEST: 'Change request',
  HELPDESK_TICKET_UPDATE_INFORMATION_REQUEST: 'Information request',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_PROBLEM: 'Problem reported',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_FAULT: 'Failure detected',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_CAUSE: 'Cause of failure',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_ACTION: 'Resolution action',
  HELPDESK_TICKET_UPDATE_LAST_UPDATE: 'Last updated',
  HELPDESK_TICKET_UPDATE_LAST_STATUS: 'Last status',
  HELPDESK_TICKET_UPDATE_INT_TYPE: 'Intervention type.',
  HELPDESK_TICKET_UPDATE_INT_TYPE_REMOTE: 'Remote',
  HELPDESK_TICKET_UPDATE_INT_TYPE_LOCAL: 'Local',
  HELPDESK_EDIT_TICKET_MODAL_TITLE: 'Edit ticket / Details',
  HELPDESK_NEW_TICKET_MODAL_TITLE: 'New status line',
  HELPDESK_EDIT_TICKET_ALERT_UPDATED_SUCCESS: 'Ticket edited',
  HELPDESK_EDIT_TICKET_ALERT_UPDATED_ERROR: 'Error editing ticket',
  HELPDESK_TICKET_ADD_LINE: 'Update status',
  HELPDESK_ADD_LINE_ALERT_UPDATED_SUCCESS: 'Line added',
  HELPDESK_ADD_LINE_ALERT_UPDATED_ERROR: 'Error adding line',

  //Helpdesk Contracts
  HELPDESK_CONTRACTS_LABEL: 'Contracts',
  HELPDESK_CONTRACTS_ID: 'Contract Id',
  HELPDESK_CONTRACTS_CREATEDATE: 'Creation',
  HELPDESK_CONTRACTS_VALUE: 'Value',
  HELPDESK_CONTRACTS_STATE: 'Contract Status',
  HELPDESK_CONTRACTS_RENEWDATE: 'Renewal',
  HELPDESK_CONTRACTS_EDIT: 'Edit Contract',
  HELPDESK_CONTRACTS_COPY: 'Copy Contract',
  HELPDESK_ADD_CONTRACTS: 'Add Contract',
  HELPDESK_AGREEMENT_NUML: 'Agreement Num',
  HELPDESK_AGREEMENT_ENTID: 'Entid',
  HELPDESK_EQUIPMENT_TYPE: 'Equipment Type',
  HELPDESK_LABOR: 'Labor',
  HELPDESK_FIRST_LINE: 'First Line',
  HELPDESK_SECOND_LINE: 'Second Line',
  HELPDESK_HARDWARE: 'Parts',
  HELPDESK_PROCESSING_SERVICE: 'Processing Service',
  HELPDESK_NEW_SOFTWARE_RELEASES: 'New Software Releases',
  HELPDESK_REPLACEMENT_PARTS: 'Replacement Parts 24 Hour Warranty',
  HELPDESK_ACCESS_PLATFORM: 'Access to the Web Platform',
  HELPDESK_DATE: 'Date',
  HELPDESK_VALUE: 'Value',
  HELPDESK_CONTRACT_YEARS: 'Contract Years',
  HELPDESK_CANCELLATION_DATE: 'Cancellation date',
  HELPDESK_LAST_RENEW_DATE: 'Last Renew Date',
  HELPDESK_REV_TYPE: 'Renew Type',
  HELPDESK_REV_VALUE: 'Renew Value',
  HELPDESK_RENOV_DATE: 'Renew Date',
  HELPDESK_NEXT_RENOV_DATE: 'Next Renew Date',
  HELPDESK_LAST_INVOICE_DATE: 'Last Invoice Date',
  HELPDESK_INVOICE_STATE: 'Invoice State',
  HELPDESK_BILLING_PERIOD: ' Billing Period',
  HELPDESK_NEXT_INVOICE_DATE: 'Next Invoice Date',
  HELPDESK_CONTRACT_STATE: 'Contract State',
  HELPDESK_SLA_CODE: 'SLA Code',
  HELPDESK_CONTRACT_NUMBER: 'Agreement Number',
  EDIT_AGREEMENT_CONTROLLER_ALERT_ADD_SUCCESS: 'Contract added',
  EDIT_AGREEMENT_CONTROLLER_ALERT_ADD_ERROR: 'Error adding contract',
  EDIT_AGREEMENT_CONTROLLER_ALERT_DELETE_SUCCESS: 'Contract deleted',
  EDIT_AGREEMENT_CONTROLLER_ALERT_DELETE_ERROR: 'Error deleting contract',
  EDIT_AGREEMENT_CONTROLLER_ALERT_EDIT_SUCCESS: 'Contract edited',
  EDIT_AGREEMENT_CONTROLLER_ALERT_EDIT_ERROR: 'Error editing contract',
  EDIT_AGREEMENT_CONTROLLER_ALERT_DELETE_CONFIRM: 'Are you sure you want to cancel the contract',
  EDIT_AGREETYPE_CONTROLLER_ALERT_ADD_SUCCESS: 'Contract type added',
  EDIT_AGREETYPE_CONTROLLER_ALERT_ADD_ERROR: 'Error deleting contract type',
  EDIT_AGREETYPE_CONTROLLER_ALERT_DELETE_SUCCESS: 'Contract type deleted',
  EDIT_AGREETYPE_CONTROLLER_ALERT_DELETE_ERROR: 'Error deleting contract type',
  EDIT_AGREETYPE_CONTROLLER_ALERT_EDIT_SUCCESS: 'Contract type edited',
  EDIT_AGREETYPE_CONTROLLER_ALERT_EDIT_ERROR: 'Error editing contract type',

  //Contract rev type
  HELPDESK_CONTRACT_REV_TYPE_1: 'n/a',
  HELPDESK_CONTRACT_REV_TYPE_2: 'Fixed value',
  HELPDESK_CONTRACT_REV_TYPE_3: 'Published value',

  // Contract invoice state
  HELPDESK_CONTRACT_INVOICE_STATE_1: 'n/a',
  HELPDESK_CONTRACT_INVOICE_STATE_2: 'Settled',
  HELPDESK_CONTRACT_INVOICE_STATE_3: 'Unpaid',

  //Contract billing period
  HELPDESK_CONTRACT_BILLING_PERIOD_1: 'n/a',
  HELPDESK_CONTRACT_BILLING_PERIOD_2: 'Monthly',
  HELPDESK_CONTRACT_BILLING_PERIOD_3: 'Quarterly',
  HELPDESK_CONTRACT_BILLING_PERIOD_4: 'Six-monthly',
  HELPDESK_CONTRACT_BILLING_PERIOD_5: 'Annual',

  // Contract state
  HELPDESK_CONTRACT_STATE_1: 'n/a',
  HELPDESK_CONTRACT_STATE_2: 'Active',
  HELPDESK_CONTRACT_STATE_3: 'Pending',
  HELPDESK_CONTRACT_STATE_4: 'Cancelled',
  HELPDESK_CONTRACT_STATE_5: 'Non-compliance',

  //Distribuitions
  DISTRIBUITIONS_ADD_BUTTON: 'Add',
  DISTRIBUITIONS_LIST: 'Distribuition list',
  ADD_DISTRIBUITION_SUCCESS: 'Distribuition added',
  ADD_DISTRIBUITION_ERROR: 'Error adding distribuition',
  EDIT_DISTRIBUITION_SUCCESS: 'Distribuition edited',
  EDIT_DISTRIBUITION_ERROR: 'Error editing distribuition',
  DELETE_DISTRIBUITION_SUCCESS: 'Distribuition deleted',
  DELETE_DISTRIBUITION_ERROR: 'Error deleting distribuition',

  //Atype
  CLIENT_CARD_INSERTED: 'Client card inserted',
  NON_READABLE_CARD: 'Non readable card',
  READABLE_CARD: 'Readable Card',
  GENERATED_NEW_TRANSACTION_KEY: 'Genereated a new transaction key',
  CHECK_OPERATION_REQUESTED: 'Check operation requested',
  CLIENT_CARD_RETURNED: 'Client card returned to client',
  CLIENT_CARD_REMOVED: 'Client card removed by client',
  CHECK_OPERATION_GOOD_RESPONSE: 'Check operation good response',
  CHECK_OPERATION_ERROR: 'Check operation error',
  CLIENT_ACCOUNT_SELECTED: 'Client account selected',
  CLIENT_ACCOUNT_INSERTED: 'Account inserted',
  CHECK_EXTERNAL_ACCOUNT_OPERATION_REQUESTED: 'Check Account operation requested',
  CHECK_EXTERNAL_ACCOUNT_OPERATION_GOOD_RESPONSE: 'Check Account operation goos response',
  CHECK_EXTERNAL_ACCOUNT_OPERATION_ERROR: 'Check Account operation error',
  CLIENT_CANCEL: 'Client cancel',
  CLIENT_CHOOSE_OR_INSERT_DEPOSIT_REASON: 'Deposit reason selected or inserted',
  ENABLED_BANKNOTES_VALIDATOR: 'Enabled banknotes validator',
  CLIENT_ACCEPTS_BANKNOTES_COUNT: 'Client accepts banknotes count',
  CLIENT_REJECT_BAKNOTES_COUNT: 'Client reject banknotes count',
  DECLARATION_AMOUNT_REACHED: 'Declaration amount reached',
  DECLARATION_SELECTED: 'Declaration selected',
  DEPOSIT_OPERATION_REQUESTED: 'Deposit operation requested',
  DEPOSIT_OPERATION_GOOD_RESPONSE: 'Deposit operation good response',
  DEPOSIT_OPERATION_ERROR: 'Deposit operation error',
  BANKNOTES_SENT_TO_SAFE: 'Banknotes sent to safe',
  BANKNOTES_DELIVERED_TO_CLIENT: 'Banknotes delivered to client',
  RECEIPT_PRINTED: 'Receipt printed',
  GOOD_USER_IDENTIFICATION: 'Good user identification',
  BAD_USER_IDENTIFICATION: 'Bad user identification',
  PERIOD_CLOSE_OPERATION: 'Period close operation',
  PERIOD_DATA_SAVED: 'Period data saved',
  SAFE_DOOR_OPENED: 'Safe door opened',
  BAG_REMOVED: 'Banknotes bag removed',
  BAG_INSERTED: 'Banknotes bag inserted',
  SAFE_DOOR_CLOSED: 'Safe door closed',
  NEW_PERIOD_OPEN: 'New period open',
  CASH_BALANCE: 'Cash Balance',
  EJECT_CARD: 'Eject Card',
  LAST_PERIOD_REPORT: 'Last period report operation',
  SHUTDOWN: 'Shutdown',
  RESTART: 'Restart',
  UNLOCK_ESCROW: 'Unlock escrow',
  IN_SERVICE: 'In service',
  OPEN_ESCROW: 'Open escrow',
  CLOSE_ESCROW: 'Close escrow',
  VPN_CONNECT: 'Connect VPN',
  VPN_DISCONNECT: 'Disconnect VPN',
  CLIENT_CARD_NOT_REMOVED: 'Client card not removed',
  MINIMUM_AMOUNT_REACHED: 'Minimum amount reached',
  MAXIMUM_AMOUNT_REACHED: 'Maximum amount reached',
  SHUTDOWN_BY_UPS_ON_BATTERY: 'Shutdown by UPS on battery',
  REMOTE_SHUTDOWN: 'Remote Shutdown',
  REMOTE_RESTART: 'Remote Restart',
  REMOTE_UNLOCK_ESCROW: 'Remote unlock escrow',
  LOCAL_UNLOCK_ESCROW: 'Local unlock escrow',
  MANUAL_OUT_OF_SERVICE_REMOVED: 'Manual Out of Service Removed',
  CENTRAL_OUT_OF_SERVICE: 'Central Out of Service',
  LOCAL_CLOSE_ESCROW: 'Local Close Escrow',
  LOCAL_OPEN_ESCROW: 'Local Open Escrow',
  REMOTE_CLOSE_ESCROW: 'Remote Close Escrow',
  REMOTE_OPEN_ESCROW: 'Remote Open Escrow',
  INVALID_ESCROW_MOVEMENT: 'Invalid Escrow Movement',
  ESCROW_NOT_EMPTY_DETECTED: 'Escrow not empty detected',
  INVALID_ACCOUNTS: 'Invalid Accounts',
  EXISTENT_CARD: 'Existent card',
  WRONG_PIN: 'Wrong pin',
  WRONG_PIN_3RD_ATTEMPT: 'Wrong pin, after 3 attemps',
  VALID_PIN: 'Valid user pin',
  NONEXISTENT_CARD: 'Nonexistent card',
  BANKNOTES_VALIDATOR_ERROR: 'Banknotes validator error',
  FAKE_NOTES_DETECTED: 'Fake notes detected',
  FAKE_NOTES_DETECTED_CLEARED: 'Fake notes detected cleared',
  NONEXISTENT_USER: 'Nonexistent user',
  EXISTENT_USER: 'Existent USER',
  REJECT_BLOCKER_ENABLE: 'Reject blocker enabled',
  REJECT_BLOCKER_DISABLE: 'Reject blocker disabled',
  FAKE_NOTES_DETECTED_CLEARED_LOCALLY: 'Fake notes detected cleared locally',

  //server:
  ATYPE_USER_INSERTED: 'User inserted',
  ATYPE_USER_DELETED: 'User deleted',
  ATYPE_USER_UPDATED: 'User updated',
  ATYPE_EQUIPMENT_INSERTED: 'Equipment inserted',
  ATYPE_EQUIPMENT_DELETED: 'Equipment deleted',
  ATYPE_EQUIPMENT_UPDATED: 'Equipment updated',
  ATYPE_OPERATION_RESTART_REQUESTED: 'Operation restart requested',
  ATYPE_OPERATION_RESTART_SENT_TO_EQUIPMENT: 'Operation restart sent to equipment',
  ATYPE_OPERATION_RESTART_EXPIRED: 'Operation restart has been expired',
  ATYPE_OPERATION_SHUTDOWN_REQUESTED: 'Operation shutdown requested',
  ATYPE_OPERATION_SHUTDOWN_SENT_TO_EQUIPMENT: 'Operation shutdown sent to equipment',
  ATYPE_OPERATION_SHUTDOWN_EXPIRED: 'Operation shutdown has been expired',
  ATYPE_OPERATION_UNLOCK_ESCROW_REQUESTED: 'Operation unlock escrow requested',
  ATYPE_OPERATION_UNLOCK_ESCROW_SENT_TO_EQUIPMENT: 'Operation unlock escrow sent to equipment',
  ATYPE_OPERATION_UNLOCK_ESCROW_EXPIRED: 'Operation unlock escrow has been expired',
  ATYPE_OPERATION_OUT_OF_SERVICE_REQUESTED: 'Operation set out of service requested',
  ATYPE_OPERATION_OUT_OF_SERVICE_SENT_TO_EQUIPMENT: 'Operation set out of service sent to equipment',
  ATYPE_OPERATION_OUT_OF_SERVICE_EXPIRED: 'Operation set out of service has been expired',
  ATYPE_OPERATION_IN_SERVICE_REQUESTED: 'Operation set in service requested',
  ATYPE_OPERATION_IN_SERVICE_SENT_TO_EQUIPMENT: 'Operation set in service sent to equipment',
  ATYPE_OPERATION_IN_SERVICE_EXPIRED: 'Operation set in service has been expired',
  ATYPE_OPERATION_OPEN_ESCROW_REQUESTED: 'Operation open escrow requested',
  ATYPE_OPERATION_OPEN_ESCROW_SENT_TO_EQUIPMENT: 'Operation open escrow sent to equipment',
  ATYPE_OPERATION_OPEN_ESCROW_EXPIRED: 'Operation open escrow has been expired',
  ATYPE_OPERATION_CLOSE_ESCROW_REQUESTED: 'Operation close escrow requested',
  ATYPE_OPERATION_CLOSE_ESCROW_SENT_TO_EQUIPMENT: 'Operation close escrow sent to equipment',
  ATYPE_OPERATION_CLOSE_ESCROW_EXPIRED: 'Operation close escrow has been expired',
  ATYPE_OPERATION_VPN_CONNECT: 'Operation connect to vpn has been requested',
  ATYPE_OPERATION_VPN_DISCONNECT: 'Operation disconnect from vpn has been requested',
  ATYPE_OPERATION_VPN_EXPIRED: 'Operation connect/disconnect has expired',
  ATYPE_OPERATION_VPN_SENT_TO_EQUIPMENT: 'Operation vpn sent to equipment',
  ATYPE_ENTITY_INSERTED: 'Entity inserted',
  ATYPE_ENTITY_DELETED: 'Entity deleted',
  ATYPE_ENTITY_UPDATED: 'Entity updated',
  ATYPE_LOCATION_INSERTED: 'Location inserted',
  ATYPE_LOCATION_DELETED: 'Location deleted',
  ATYPE_LOCATION_UPDATED: 'Location updated',
  ATYPE_CURRENCY_INSERTED: 'Currency inserted',
  ATYPE_CURRENCY_DELETED: 'Currency deleted',
  ATYPE_CURRENCY_UPDATED: 'Currency updated',
  ATYPE_OPERATION_IGNORED: 'Operation ignored by equipment due to unknown operation type on equipment',
  ATYPE_PRODUCT_EDITED: 'Product edited',
  ATYPE_PRODUCT_DISPENSER_EDITED: 'Product dispenser edited',
  ATYPE_UPDATE_USER_BALANCE: 'Update user balance',
  ATYPE_ERROR: 'Audit Type not recognized',

  //Helpdesk Devices
  HELPDESK_PRODUCT_CODE: 'Product Code',

  //Helpdesk Product Management
  PRODUCT_MANAGEMENT: 'Product Management',
  PRODUCT_MANAGEMENT_SMALL: 'Prod. Manag.',
  PRICE_REFERENCE: 'Price reference',
  LAST_SUPPLIER: 'Last supplier',
  LAST_PRICE: 'Last price',
  AVERAGE_DELIVERY_TIME: 'Average delivery time',
  AVERAGE_DELIVERY_TIME_MIN: 'Avrg. Deli. Time',
  CE_CERTIFICATE: 'CE Certificate',
  CB_CERTIFICATE: 'CB Certificate',
  PRODUCT_ADD_PRODUCT: 'Add Product',
  PRODUCT_DEV_TYPE: 'Device Type',
  ADD_PRODUCT_SUCCESS: 'Product added',
  EDIT_PRODUCT_SUCCESS: 'Product updated',
  DELETE_PRODUCT_SUCCESS: 'Product deleted',
  ADD_PRODUCT_ERROR: 'Failed to add product',
  EDIT_PRODUCT_ERROR: 'Failed to update product',
  DELETE_PRODUCT_ERROR: 'Failed to delete product',

  //Sync commands
  SYNC_COMMANDS_DELETE_SUCCESS: 'Sync command deleted',
  SYNC_COMMANDS_DELETE_ERROR: 'Error deleting sync command',
  SYNC_COMMANDS_ADD_SUCCESS: 'Sync command added',
  SYNC_COMMANDS_ADD_ERROR: 'Error adding sync command',

  //User shift
  USER_SHIFT_AMOUNT_RECEIVED: 'Amount Received',
  USER_SHIFT_TITLE: 'Shifts',
  USER_SHIFTS_METHODS_CARD: 'Card (MB)',
  USER_SHIFTS_METHODS_CASH: 'Cash',
  USER_SHIFTS_REPORT_ERROR: 'Error getting report',

  //Brisa Users Summaries
  BRISA_USERS_SUMMARIES_TITLE: 'User summaries',
  BRISA_USERS_SUMMARIES_ID: 'ID',
  BRISA_USERS_SUMMARIES_USER_ID: 'User ID',
  BRISA_USERS_SUMMARIES_NAME: 'Name',
  BRISA_USERS_SUMMARIES_USER_NAME: 'User name',
  BRISA_USERS_SUMMARIES_LAST_OPER: 'Last operation',
  BRISA_USERS_SUMMARIES_EID_LAST_OPER: 'EID (last oper.)',
  BRISA_USERS_SUMMARIES_DATE_LAST_OPER: 'Date (last oper.)',
  BRISA_USERS_SUMMARIES_AMOUNT_LAST_OPER: 'Amount (last oper.)',
  BRISA_USERS_SUMMARIES_AMOUNT_ADD: 'Amount to add (+/-)',
  BRISA_USERS_SUMMARIES_BALANCE: 'Balance',
  BRISA_USERS_SUMMARIES_WITH_BALANCE: 'With balance',
  BRISA_USERS_SUMMARIES_CURRENT_BALANCE: 'Current balance',
  BRISA_USERS_SUMMARIES_BALANCE_ZERO: 'Balance at 0 (zero)',
  BRISA_USERS_SUMMARIES_MENU_FIX_BALANCE: 'Fix balance',
  BRISA_USERS_SUMMARIES_MENU_FIX_TRANSACTIONS: 'Transactions',
  BRISA_USER_SUMMARY_EDIT: 'Edit user summary',
  BRISA_USER_SUMMARY_EDIT_SUCCESS: 'Order successfully registered, will be sent to the equipment for processing',
  BRISA_USER_SUMMARY_EDIT_ERROR: 'Error editing user summary',
  BRISA_USER_SUMMARY_ADD: 'Add user summary',
  BRISA_USER_SUMMARY_ADD_SUCCESS: 'User summary added',
  BRISA_USER_SUMMARY_ADD_ERROR: 'Error adding user summary',
  BRISA_USER_SUMMARY_DELETE_SUCCESS: 'User summary removed',
  BRISA_USER_SUMMARY_DELETE_ERROR: 'Error removing user summary',

  //Brisa Withdraw sets
  BRISA_WITHDRAW_SETS_TITLE: 'Withdraw Sets',
  BRISA_WITHDRAW_SETS_ENTITY: 'Entity',
  BRISA_WITHDRAW_SETS_ID: 'ID',
  BRISA_WITHDRAW_SETS_DESCRIPTION: 'Description',
  BRISA_WITHDRAW_SETS_AMOUNT: 'Amount',
  BRISA_WITHDRAW_SETS_TYPE: 'Type',
  BRISA_WITHDRAW_SETS_QUANTITY: 'Quantity',
  BRISA_WITHDRAW_SETS_EDIT: 'Edit Withdraw Set',
  BRISA_WITHDRAW_SETS_EDIT_SUCCESS: 'Withdraw set updated',
  BRISA_WITHDRAW_SETS_EDIT_ERROR: 'Failed to update withdraw set',
  BRISA_WITHDRAW_SETS_ADD: 'Add Withdraw Set',
  BRISA_WITHDRAW_SETS_ADD_SUCCESS: 'Withdraw set added',
  BRISA_WITHDRAW_SETS_ERROR: 'Failed to add withdraw set',
  BRISA_WITHDRAW_SETS_DELETE_SUCCESS: 'Withdraw set deleted',
  BRISA_WITHDRAW_SETS_DELETE_ERROR: 'Failed to delete withdraw set'
};
